<div class="card-header bg-success">
  <div class="row">
    <div class="col-md-6">
      <h3 class="text-white">
        Quote: {{ quoteDetails?.quote_ref_number || '—' }}
        <span class="badge ml-2" [ngClass]="statusBadgeClass" style="font-size: 0.55em; vertical-align: middle;">{{ statusLabel }}</span>
      </h3>
    </div>
    <div class="col-md-6 text-right" *ngIf="quoteDetails?.id && !loading">
      <span>
        <a [routerLink]="['/equine', 'quote', quoteId]" class="btn btn-danger btn-sm mr-2">Edit</a>
      </span>
      <span *ngIf="!isDeclined && !isInProgress">
        <button type="button" class="btn btn-warning btn-sm mr-2" (click)="regenerateDocument()" [disabled]="regenerating">
          {{ regenerating ? 'Regenerating...' : 'Re-generate Document' }}
        </button>
      </span>
      <span *ngIf="isReferred && !isBroker">
        <button type="button" class="btn btn-secondary btn-sm mr-2" (click)="openDeclineModal(declineModal)" [disabled]="declining">
          {{ declining ? 'Declining...' : 'Decline Quote' }}
        </button>
        <button type="button" class="btn btn-info btn-sm" (click)="convertToQuote()" [disabled]="convertingToQuote">
          {{ convertingToQuote ? 'Converting...' : 'Convert to Quote' }}
        </button>
      </span>
      <span *ngIf="!isReferred && !isDeclined && !isExpired && !isInProgress">
        <button type="button" class="btn btn-dark btn-sm" (click)="openConvertModal(convertModal)">
          Convert to Policy
        </button>
      </span>
    </div>
  </div>
</div>

<div *ngIf="loading" class="card-body text-center py-5">
  <p>Loading quote...</p>
</div>

<mat-tab-group class="float-left w-100" [(selectedIndex)]="selectedIndex" *ngIf="!loading && quoteDetails?.id">
  <mat-tab>
    <ng-template mat-tab-label>Overview</ng-template>
    <div class="card-body">
      <app-equine-quote-overview
        [quoteDetails]="quoteDetails"
        [staticData]="staticData"
        [isBroker]="isBroker">
      </app-equine-quote-overview>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Full Details</ng-template>
    <div class="card-body">
      <app-equine-quote-full-details [quoteDetails]="quoteDetails" [staticData]="staticData"></app-equine-quote-full-details>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Financials</ng-template>
    <div class="card-body">
      <app-equine-quote-financials 
        [quoteDetails]="quoteDetails" 
        [adjustedPremiumDetails]="adjustedPremiumDetails"
        [adjustmentValues]="premiumAdjustments"
        [adjustedPremiumDetails]="adjustedPremiumDetails"
        [adjustmentSaving]="premiumAdjustmentSaving"
        (adjustmentChange)="onPremiumAdjustmentsChange($event)"
        (adjustmentSave)="onPremiumAdjustmentsSave($event)"
        [isBroker]="isBroker">
      ></app-equine-quote-financials>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Documents</ng-template>
    <div class="card-body">
      <app-equine-quote-documents [quote]="quoteDetails"></app-equine-quote-documents>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
        Notes <span *ngIf="hasImportantNotes" class="ml-1" style="color: #ff0000" title="{{totalImpNotes}} Important Notes"><i class="mdi mdi-alert-circle"></i></span>
    </ng-template>
    <div class="card-body">
      <app-quote-notes [quote]="quoteDetails" [isEquine]="true" (hasImportantNotes)="onhasImportantNotesChange($event)"></app-quote-notes>
    </div>
  </mat-tab>
  <mat-tab *ngIf="isAdmin">
    <ng-template mat-tab-label>
        Email 
    </ng-template>
    <div class="card-body"> 
      <app-quote-email (emailView)="getEmailView($event)" 
            (newEmailView)="newEmailView()"
            [quote]="quoteDetails"
            *ngIf="!displayEmailView && !displayNewEmailView"></app-quote-email>
      <app-quote-email-view (backToEmailsList)="backToEmailsList()" [email_id]="email_id"  *ngIf="displayEmailView"></app-quote-email-view>
      <app-quote-email-compose (backToEmailsList)="backToEmailsList()" [quote]="quoteDetails"  *ngIf="displayNewEmailView"></app-quote-email-compose>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #convertModal let-modal>
  <div class="modal-body">
    <p>Convert this quote to a policy? This action cannot be undone.</p>
    <p class="small text-muted mb-2" *ngIf="isBroker && !isMtaConversion">Policy start date must be today or a future date (up to 14 days ahead).</p>
    <p class="small text-muted mb-2" *ngIf="!isBroker && !isMtaConversion">Select the policy start date. Peliwica Admin may backdate if required; maximum 14 days in the future.</p>
    <div class="form-group mb-0" *ngIf="!isMtaConversion">
      <label class="mb-1">Policy start date <span class="text-danger">*</span></label>
      <div class="w-100">
        <input
          type="text"
          required
          name="convert_policy_start_date"
          [(ngModel)]="convertPolicyStartDate"
          (ngModelChange)="onConvertPolicyStartChange()"
          placeholder="Policy start date"
          class="form-control form-control-sm datepicker"
          matInput
          (click)="convertPolicyPicker.open()"
          (focus)="convertPolicyPicker.open()"
          [matDatepicker]="convertPolicyPicker"
          [min]="convertModalMinDate"
          [max]="convertModalMaxDate"
          (dateChange)="onConvertPolicyStartChange()"
          [ngClass]="{ 'is-invalid': convertPolicyStartInvalid }"
        />
        <mat-datepicker-toggle [for]="convertPolicyPicker"></mat-datepicker-toggle>
        <mat-datepicker #convertPolicyPicker></mat-datepicker>
      </div>
      <div class="invalid-feedback d-block" *ngIf="convertPolicyStartInvalid">
        <span *ngIf="isBroker">Policy start date cannot be in the past.</span>
        <span *ngIf="!isBroker">Policy start date must be within the allowed range.</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-sm" (click)="modal.dismiss()" [disabled]="converting">Cancel</button>
    <button type="button" class="btn btn-success btn-sm" (click)="convertToPolicy(modal)" [disabled]="converting || convertPolicyStartInvalid">
      {{ converting ? 'Converting...' : 'Yes, convert' }}
    </button>
  </div>
</ng-template>

<ng-template #declineModal let-modal>
  <div class="modal-body">
    <p>Are you sure you want to decline this quote?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-sm" (click)="modal.dismiss()" [disabled]="declining">Cancel</button>
    <button type="button" class="btn btn-danger btn-sm" (click)="declineQuote(modal)" [disabled]="declining">
      {{ declining ? 'Declining...' : 'Yes, decline' }}
    </button>
  </div>
</ng-template>
